import { styled } from '@mui/material'
import React from 'react';
import HTMLReactParser from 'html-react-parser';

interface ComponentProps {
    IsActive: boolean;
    Messages:string;
    Id:number;
    RouteType:string;
}

const ViewRouteContent: React.FC<ComponentProps> = ({ IsActive,Messages,Id,RouteType }) => {
  return (
        <StyledContainer>
        <StyledWrapper>
            {
                HTMLReactParser(`
                <div>
                    ${Messages}               
                </div>
                `)
            }
        </StyledWrapper>
    </StyledContainer>
  )
}

export default ViewRouteContent

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 3rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
    
`

const StyledWrapper = styled('div')`
    overflow: auto;
`
